import { Post } from 'framework/posts'
import type { FC } from 'react'
import { useState, useEffect } from 'react'
import { PostCard } from 'modules/posts/components'
import type { PostSectionProps } from '.'
import s from './post-section.module.css'
import { POSTS } from '../../constants'
import PostsService from 'modules/posts/services/posts-service'
import { slugify } from 'helpers/slugfy'

const formatDate = (dateString: string) => {
  const months = [
    'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
    'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'
  ];

  const date = new Date(dateString);
  const day = date.getUTCDate();
  const month = months[date.getUTCMonth()];
  const year = date.getUTCFullYear();

  return `${day} de ${month} de ${year}`;
};

const PostSection: FC<PostSectionProps> = ({ ignore = '', limit = 3 }) => {

  const [posts, setPosts] = useState<Post[]>([]);

  const postService = new PostsService();

  useEffect(() => {
    const getPosts = async () => {
      const postsResponse = await postService.getAllPosts();
      setPosts(postsResponse.data?.data);

      let trasformedPosts = [];

      if(postsResponse.data && postsResponse.data.data && Array.isArray(postsResponse.data.data)) {

        trasformedPosts = postsResponse.data.data.filter((post: any) => post.ativo !== 0);

        trasformedPosts = trasformedPosts.map((post: any) => {
          return {
            id: post.id,
            categories: [{ name: post.categoria, slug: slugify(post.categoria) }],
            content: post.conteudo,
            createdAt: formatDate(post.created_at),
            description: post.descricao,
            image: {
              url: post.imagem
            },
            slug: slugify(post.titulo),
            title: post.titulo,
          } as Post
        })
      }

      setPosts([...trasformedPosts, ...POSTS]);
    }

    getPosts();
  }, []);

  return (
    <div className={s.root}>
      {posts.filter(({ slug }) => slug !== ignore).map(
        (post, index) => index < limit && <PostCard post={post as unknown as Post} />,
      )}
    </div>
  )
}

export default PostSection
